import Tiptap from "./Tiptap.jsx";
import './App.css';

const App = () => {
  return (
    <div className="App">
      <Tiptap />
    </div>
  );
};

export default App;
